import { render, staticRenderFns } from "./Achievments.vue?vue&type=template&id=8092556c&"
import script from "./Achievments.vue?vue&type=script&lang=js&"
export * from "./Achievments.vue?vue&type=script&lang=js&"
import style0 from "./Achievments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports